import { Navigate } from "react-router-dom";

import { useDirectorContext } from "@contexts/director";

const DirectorRoute = ({ children, capability = "director.view" }) => {
  const { bootstrapStatus, selectedCompanyId, accessByCompany } = useDirectorContext();
  if (bootstrapStatus === "idle" || bootstrapStatus === "loading") {
    return <div className="director-route-status" role="status">Validando acesso à Visão Diretoria…</div>;
  }
  const access = selectedCompanyId ? accessByCompany[selectedCompanyId] : null;
  const capabilities = access?.capabilities || [];
  if (!capabilities.includes("director.view") || !capabilities.includes(capability)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default DirectorRoute;
